var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _ellipse2, _ellipse3, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse4, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorVehicle = function SvgErrorVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 244,
    viewBox: "0 0 250 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.65 200.57C53.3773 193.97 78.1896 161.404 45.9489 134.661C23.2078 115.799 34.14 85.4546 49.3734 66.2159C64.6067 46.9771 89.1411 42.8154 123.759 42.8803C158.377 42.9452 180.258 47.9345 189.428 75.9295C197.277 99.8917 217.819 101.196 214.075 142.755C210.331 184.314 181.412 182.339 169.183 193.981C156.955 205.623 131.247 204.616 101.65 200.57Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3968 148.515H57.3466L58.8698 126.18L23.3968 125.408V148.515Z",
    fill: "#2F2E41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.64 148.515L181.279 147.619L177.113 126.18L141.64 125.408V148.515Z",
    fill: "#2F2E41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.066,
    cy: 144.388,
    rx: 14.3581,
    ry: 14.0289,
    fill: "#2F2E41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.984 153.466H57.7244C57.7244 153.466 58.6671 127.86 40.3925 127.86C22.1179 127.86 23.8462 149.406 23.8462 149.406L20.9922 147.786C20.9922 147.786 17.4591 136.006 18.6135 131.31C19.768 126.614 25.3823 117.93 31.26 110.539C37.1377 103.148 49.3096 92.0199 49.3096 92.0199C49.3096 92.0199 54.3653 87.4477 62.5487 87.4477C69.5823 87.4477 108.576 87.9854 119.396 88.1365C121.231 88.1621 122.991 88.7225 124.512 89.7493L150.35 107.19H157.887L199.687 120.184C202.274 120.989 204.108 123.293 204.311 125.995L205.829 146.189C205.829 146.189 205.735 146.523 205.255 147.155C204.776 147.786 203.956 147.786 203.956 147.786H177.457C177.457 147.786 178.335 129.309 160.204 129.309C142.074 129.309 142.984 153.466 142.984 153.466Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8605 89.0982L70.6941 108.904H78.2676L79.1401 89.0982H73.8605Z",
    fill: "#8A8A8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.748 90.7484C124.748 90.7484 127.244 91.7614 128.81 92.5259C130.375 93.2903 158.532 107.253 158.532 107.253H150.957L129.411 93.6889L124.748 90.7484Z",
    fill: "#2F2E41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1333,
    cy: 144.388,
    rx: 14.3581,
    ry: 14.0289,
    fill: "#2F2E41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1502,
    cy: 144.45,
    rx: 8.44595,
    ry: 8.25231,
    fill: "#E1E0E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2021 109.575C47.1317 109.7 47.2216 109.855 47.3653 109.856L146.708 110.554L122.731 91.0266C121.2 89.7793 119.285 89.0982 117.31 89.0982H61.2449C59.6763 89.0982 58.2298 89.9447 57.4615 91.3123L47.2021 109.575Z",
    fill: "#2F2E41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1044 88.2548L69.0049 110.554H76.6038L77.567 88.2548H72.1044Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.621 128.709H189.625C186.073 128.709 184.181 132.898 186.529 135.563V135.563C187.312 136.452 188.44 136.962 189.625 136.962H204.14",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8366 112.205C29.8366 112.205 33.4667 112.814 32.9775 113.821C32.4882 114.828 27.582 120.961 23.2427 121.814C24.9025 119.132 29.8366 112.205 29.8366 112.205Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2727 112.487C30.2506 112.289 29.6114 112.35 29.0938 112.688C28.5763 113.025 25.0244 117.969 24.619 119.924C24.2135 121.88 27.9458 118.903 27.9458 118.903C27.9458 118.903 33.7302 114.016 32.9273 113.43C32.9273 113.43 32.2947 112.685 31.2727 112.487Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.534 105.602C130.534 105.602 129.816 106.665 129.816 108.903C129.816 111.142 130.534 112.204 130.534 112.204C130.534 112.204 131.864 112.123 133.753 111.446C135.21 110.923 136.731 109.877 137.35 109.426C137.499 109.318 137.499 109.102 137.352 108.991C136.701 108.5 135.065 107.313 133.753 106.748C132.075 106.026 130.534 105.602 130.534 105.602Z",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.60135,
    cy: 7.42709,
    rx: 7.60135,
    ry: 7.42709,
    transform: "matrix(-1 0 0 1 168.667 136.962)",
    fill: "#E1E0E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133 113.75L117 129.75M117 113.75L133 129.75",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgErrorVehicle;